import styled from "styled-components";
import { BaseLoaderProps, LoaderTestIds } from "./BaseLoader";

export type SquareDotLoadingIndicatorProps = BaseLoaderProps & {
  speed?: number;
};

export const SquareDotLoadingIndicator = ({
  speed = 1,
  testId = LoaderTestIds.SquareLoader,
  className,
  id,
}: SquareDotLoadingIndicatorProps) => {
  return (
    <StyledLoader
      speed={speed}
      className={className}
      data-testid={testId}
      id={id}
    >
      <div className="loader-icon-square"></div>
    </StyledLoader>
  );
};

const StyledLoader = styled.div<SquareDotLoadingIndicatorProps>`
  .loader-icon-square {
    animation: rotate-square-loader ${(props) => props.speed}s infinite;
    margin-top: -0.75rem;
    height: 50px;
    width: 50px;
  }

  .loader-icon-square:before,
  .loader-icon-square:after {
    animation: square-loader-circle-1 ${(props) => props.speed}s infinite;
    border-radius: 50%;
    content: "";
    display: block;
    height: 20px;
    width: 20px;
  }

  .loader-icon-square:before {
    animation: square-loader-circle-1 ${(props) => props.speed}s infinite;
    background-color: var(--color-primary-300);
    box-shadow: 30px 0 0 var(--color-neutral-300);
    margin-bottom: 10px;
  }
  .loader-icon-square:after {
    animation: square-loader-circle-2 ${(props) => props.speed}s infinite;
    background-color: var(--color-secondary-600);
    box-shadow: 30px 0 0 var(--color-neutral-300);
  }

  @keyframes rotate-square-loader {
    0% {
      transform: rotate(0deg) scale(0.8);
    }
    50% {
      transform: rotate(360deg) scale(1.2);
    }
    100% {
      transform: rotate(720deg) scale(0.8);
    }
  }

  @keyframes square-loader-circle-1 {
    0% {
      box-shadow: 30px 0 0 var(--color-primary-900);
    }
    50% {
      box-shadow: 0 0 0 var(--color-primary-900);
      margin-bottom: 0;
      transform: translate(15px, 15px);
    }
    100% {
      box-shadow: 30px 0 0 var(--color-primary-900);
      margin-bottom: 10px;
    }
  }

  @keyframes square-loader-circle-2 {
    0% {
      box-shadow: 30px 0 0 var(--color-primary-600);
    }
    50% {
      box-shadow: 0 0 0 var(--color-primary-600);
      margin-top: -20px;
      transform: translate(15px, 15px);
    }
    100% {
      box-shadow: 30px 0 0 var(--color-primary-600);
      margin-top: 0;
    }
  }
`;
